/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { ExtractFileTreeFile } from './ExtractFileTreeFile';
const ExtractFileTreeDirectoryParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'entries',
        /* #__PURE__ */ parsers.lazy(() => 
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecOneOf([ExtractFileTreeDirectory, ExtractFileTreeFile]))),
    ],
]), ExtractFileTreeFile);
export class ExtractFileTreeDirectory extends ExtractFileTreeFile {
    static decode(input) {
        return ExtractFileTreeDirectoryParser.decode(input).map(res => new ExtractFileTreeDirectory(res));
    }
    static unsafeDecode(input) {
        return ExtractFileTreeDirectory.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtractFileTreeDirectoryParser.encode(data);
    }
    static schema() {
        return ExtractFileTreeDirectoryParser.schema();
    }
}
